import { useLabel } from '~hooks/useLabels';
import { CheckboxButton } from '~modules/media-library/view/Checkbox';

export function RestrictionCheckbox({ isChecked, onCheck }: { isChecked: boolean; onCheck: () => void }) {
  const label = useLabel('msgMediaLibraryAssetRestricted');
  return (
    <CheckboxButton isChecked={isChecked} onClick={onCheck}>
      <span className="text-red">{label}</span>
    </CheckboxButton>
  );
}
